export default __webpack_public_path__ + "static/media/oa_6.c372bf57.mp3";